import unescapedText from 'I18n/utils/unescapedText';
export const auditLogSummaryActionTextParser = action => {
  return unescapedText(`copilotToolkit.streamingMessage.objectSummary.summarize.default`, {
    label: action.label
  });
};